<template>
  <div class="row">
    <ModalConfirm 
      modalId="modalRemoveBuyerReason" 
      :text="`Are you sure to remove this buyer cancel reason?`"
      @onClick="removebuyer"
      :center="true"
    />
    <ModalConfirm 
      modalId="modalRemoveSellerReason" 
      :text="`Are you sure to remove this seller cancel reason?`"
      @onClick="removeseller"
      :center="true"
    />
    <div class="col-md-6">
      <div class="card">
        <div
          class="d-flex justify-content-between p-3 rounded-top"
          style="background-color: #f3f2f8"
        >
          <div class="text-start">Buyer Cancel Reason</div>
          <div class="">Action</div>
        </div>
        <div v-if="loading">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-else v-for="(input, k) in cancelbuyer" :key="k">
          <div class="d-flex align-items-center px-4 py-3 border-bottom">
            <div class="me-auto w-100">
              <input
                v-model="input.name"
                :name="'value' + k"
                id="input-1"
                class="form-control border-0 bg-white"
                disabled
                placeholder="Value"
              />
            </div>
            <div class="d-flex justify-content-end">
              <div
                style="text-decoration: none; cursor: pointer"
                class="text-danger"
                @click="selectedReasonBuyer = input._id"
                data-bs-toggle="modal" 
                data-bs-target="#modalRemoveBuyerReason"
              >
                <i class="far fa-trash-alt"></i>
              </div>
            </div>
          </div>

          <div></div>
        </div>
        <div class="d-flex px-4 py-3" style="width: 100%">
          <input
            v-model="buyer_data"
            id="input-1"
            class="form-control shadow-none border-0"
            placeholder="type cancelation reason"
            maxlength="64"
          />
          <button
            style="white-space: nowrap"
            class="btn btn-danger"
            @click="addbuyer()"
            :disabled="!buyer_data"
          >
            Add Reason
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div
          class="d-flex justify-content-between p-3 rounded-top"
          style="background-color: #f3f2f8"
        >
          <div class="text-start">Seller Cancel Reason</div>
          <div class="">Action</div>
        </div>
        <div v-if="loading">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-else v-for="(input, k) in cancelseller" :key="k">
          <div class="d-flex align-items-center px-4 py-3 border-bottom">
            <div class="me-auto w-100">
              <input
                v-model="input.name"
                :name="'value' + k"
                id="input-1"
                class="form-control border-0 bg-white"
                placeholder="Value"
                disabled
              />
            </div>
            <div class="d-flex justify-content-end">
              <div
                style="text-decoration: none; cursor: pointer"
                class="text-danger"
                @click="selectedReasonSeller = input._id"
                data-bs-toggle="modal" 
                data-bs-target="#modalRemoveSellerReason"
              >
                <i class="far fa-trash-alt"></i>
              </div>
            </div>
          </div>

          <div></div>
        </div>
        <div class="d-flex px-4 py-3" style="width: 100%">
          <input
            v-model="seller_data"
            id="input-1"
            class="form-control shadow-none border-0"
            placeholder="type cancelation reason"
          />
          <button
            style="white-space: nowrap"
            class="btn btn-danger"
            @click="addseller()"
            :disabled="!seller_data"
          >
            Add Reason
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalConfirm from "@/components/ModalConfirm.vue"
export default {
  components:{
    ModalConfirm
  },
  data() {
    return {
      buyer_data: "",
      seller_data: "",
      loading: false,
      cancelbuyer: [],
      cancelseller: [],
      selectedReasonSeller: "",
      selectedReasonBuyer: ""
    };
  },
  mounted() {
    this.$store
      .dispatch("order/getAllCancelation")
      .then((response) => {
        this.cancelbuyer = response.data.data.buyer_order_cancel_reason;
        this.cancelseller = response.data.data.seller_order_cancel_reason;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    refreshdata() {
      console.log("masuk");
      this.$store
        .dispatch("order/getAllCancelation")
        .then((response) => {
          this.cancelbuyer = response.data.data.buyer_order_cancel_reason;
          this.cancelseller = response.data.data.seller_order_cancel_reason;
        })
        .catch(() => {
          // console.log(error);
        });
    },
    async updateCancel(value) {
      await this.$store
        .dispatch("order/updateCancelReason", value)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
      this.refreshdata();
    },
    addbuyer() {
      let payload = new FormData();
      payload.append("add_buyer_reason", this.buyer_data);
      this.updateCancel(payload);
      this.buyer_data = "";
    },
    removebuyer() {
      let payload = new FormData();
      payload.append("remove_buyer_reason_id", this.selectedReasonBuyer);
      this.updateCancel(payload);
    },
    addseller() {
      let payload = new FormData();
      payload.append("add_seller_reason", this.seller_data);
      this.updateCancel(payload);
      this.seller_data = "";
    },
    removeseller() {
      let payload = new FormData();
      payload.append("remove_seller_reason_id", this.selectedReasonSeller);
      this.updateCancel(payload);
    },
  },
};
</script>

<style scoped>
  .form-control{
    padding: 0
  }
</style>
